<template>
	<V2Layout><div class="v2-page-wrap">
		<OriginalComponent v-bind="$route.params" :key="$route.fullPath" />
	</div></V2Layout>
</template>

<script>
import V2Layout from '@/layouts/V2Layout';
import OriginalComponent from '@/pages/advertiser/add.vue';

export default {
	name: 'V2AdvertiserAdd',
	components: { V2Layout, OriginalComponent },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/styles/v2-page-overrides'
</style>
